export default __webpack_public_path__ + "static/media/lead-claire.69a10fb6.png";